import React, { useCallback, useEffect, useState } from 'react';
import {
  Grid,
} from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import {makeStyles} from "@mui/styles";
import { statusTotal } from '../components'
import Header from '../components/settlement/Header'
import Content from '../components/settlement/Content'

import {makeStartDate, makeEndDate, changeDocumentTitle} from '../lib'
import SettlementService from "../services/settlement";
import {useNavigate} from "react-router-dom";

const useStyles = makeStyles(() => ({
  headerContainer: {
    height: 57,
    paddingTop: 7,
    paddingRight: 27,
    paddingLeft: 18,
    backgroundColor: '#ffffff',
    borderRadius: 3.8,
    border: 'solid 1px #ebedf8',
  },
  contentContainer: {
    marginTop: 25,
    padding: 0,
    backgroundColor: '#ffffff',
    borderRadius: 3.8,
    border: 'solid 1px #ebedf8',
  },
}));

export default function Settlement() {
  const classes = useStyles();

  const navigate = useNavigate();
  const methods = useForm();

  const [settlements, setSettlements] = useState<any[]>([]);
  const [summary, setSummary] = useState(null);

  const inquiry = useCallback(async (data: any) => {
    try {
      const settlementService = new SettlementService(navigate);
      const response = await settlementService.inquiry(data);
      setSettlements(response.data.settlements);
      setSummary(response.data.summary);
    } catch(e) {
      console.error('failed to handle settlements:', e);
    }
  }, [setSettlements])

  const onSubmit = async (data:any) => {
    await inquiry(data)
  }

  useEffect(() => {
    changeDocumentTitle("정산");
    queueMicrotask(async () => {
      const startDate = new Date();
      startDate.setDate(0); // 지난 달 마지막 날로 셋팅
      startDate.setDate(1); // 지난 달 1일로 셋팅
      makeStartDate(startDate);

      const endDate = new Date();
      endDate.setDate(0); // 지난 달 마지막 날로 셋팅
      makeEndDate(endDate);

      await inquiry({ status: statusTotal, startDate, endDate })
    })
  }, [])

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Grid container direction={'column'}>
          <Grid item className={classes.headerContainer}>
            <Header summary={summary}/>
          </Grid>
          <Grid item className={classes.contentContainer}>
            <Content settlements={settlements}/>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
}
